// Third party
import React from 'react';

// Utils
import { FormattedMessage } from '@/utils/i18n';

export default function ESGNoSelection() {
  return (
    <div className="esg-no-selection">
      <span className="esg-no-selection-icon">
        <i className="icon-plus-med" />
      </span>
      <FormattedMessage tagName="h4" id="ESGComparisonTool.NoSelection.Title" />
      <FormattedMessage tagName="p" id="ESGComparisonTool.NoSelection.SubTitle" />
    </div>
  );
}
